import { useState, useEffect } from 'react';

export const useOnScreen = (
  ref: React.MutableRefObject<Element | null> | { current: Element } | undefined,
  rootMargin = '0px',
  threshold = 0,
): boolean | undefined => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState<boolean | undefined>();

  useEffect(() => {
    if (window?.IntersectionObserver) {
      const observer = new window.IntersectionObserver(
        ([entry]) => {
          // Update our state when observer callback fires
          setIntersecting(entry.isIntersecting);
        },
        {
          rootMargin,
          threshold,
        },
      );
      if (ref?.current) {
        observer.observe(ref.current);
      }

      // The ref value 'ref.current' will likely have changed by the time this effect cleanup function runs.
      // If this ref points to a node rendered by React, copy 'ref.current' to a variable inside the effect,
      // and use that variable in the cleanup function.eslintreact-hooks/exhaustive-deps
      const theRef = ref?.current;
      return () => {
        try {
          theRef && observer.unobserve(theRef);
        } catch (e) {
          // console.log(e);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isIntersecting;
};
